import type { LocationQueryRaw } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) {
    return;
  }

  const { init, setWidgetPageLayout, isWidgetState, updateInitialPage } = useWidget();

  if (to.path.includes('/widget/')) {
    init(to);
  }

  if (isWidgetState.value) {
    const { loadTheme, widgetConfig } = useWidgetTheme();

    await callOnce('widget-theme', async () => {
      await loadTheme();
    });

    const eventIdFromQuery = to.query.eventId;
    const isSingleEventWidget = widgetConfig.value?.singleEventWidget;
    const eventId = isSingleEventWidget ? widgetConfig.value?.dataSource?.eventIds?.[0] : eventIdFromQuery;

    const widgetQueryParams = widgetConfig.value?.queryParams;

    // Set shop provider from widget query params before setting widget session in all types of widgets
    if (widgetQueryParams?.sp) {
      useShopProvider().setShopProvider(widgetQueryParams.sp);
    }

    if (eventId && !Array.isArray(eventId) && to.query.language) {
      const eventPath = useEventPath({ id: String(eventId), sluggedName: 'event' }, String(to.query.language));
      // Update initial page for list events widget if single event is provided through the query
      if (!isSingleEventWidget) {
        const { eventId: _eventId, ...listQuery } = to.query;
        updateInitialPage({ fullPath: '/widget/list', query: listQuery });
      }
      return navigateTo({ path: eventPath, query: widgetQueryParams as LocationQueryRaw });
    }

    setWidgetPageLayout();
  }
});
